import React from 'react';

import Spinner from '@atlaskit/spinner/spinner';

import { LoadableLazy } from '@confluence/loadable';
import { expVal } from '@confluence/feature-experiments';

import { LazyCommentEditorPlaceholder } from './LazyCommentEditorPlaceholder';

export const LazyCommentEditor = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentEditor" */ './CommentEditor'))
			.CommentEditor,
	loading: () => (
		<div>
			<Spinner size="medium" interactionName="comment-editor-loadable" />
		</div>
	),
	waitForNetworkOnline: () => expVal('platform_editor_offline_editing_web', 'isEnabled', false),
});

export const LazyInlineCommentEditor = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentEditor" */ './CommentEditor'))
			.CommentEditor,
	loading: () => <LazyCommentEditorPlaceholder />,
	waitForNetworkOnline: () => expVal('platform_editor_offline_editing_web', 'isEnabled', false),
});

export const LazyCommentEditorWithoutSpinner = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CommentEditor" */ './CommentEditor'))
			.CommentEditor,
	waitForNetworkOnline: () => expVal('platform_editor_offline_editing_web', 'isEnabled', false),
});
